import React, { useEffect, useState } from 'react';
import { Field, Input, Stack, Text } from '@chakra-ui/react';
import AuthDialog from '../ui/AuthDialog';
import { FormActions, LinkButton, PrimaryButton, SecondaryButton } from '../ui/FormActions';

function LoginModal({ open, onClose, onSubmit, onSwitch, onForgotPassword, lang }) {
  const [identifierInput, setIdentifierInput] = useState('');
  const [password, setPassword] = useState('');
  const [submitError, setSubmitError] = useState('');

  const isEn = lang === 'en';

  useEffect(() => {
    if (open) {
      setSubmitError('');
    }
  }, [open]);

  return (
    <AuthDialog
      open={open}
      onClose={onClose}
      title={isEn ? 'Log in' : '登录'}
      description={
        isEn ? 'Use your account to sign in to AEVDIR console.' : '使用你的账户登录 AEVDIR 控制台。'
      }
    >
      {submitError ? (
        <Text fontSize="sm" color="red.500" mb={3}>
          {submitError}
        </Text>
      ) : null}
      <form
        onSubmit={async (e) => {
          e.preventDefault();
          setSubmitError('');
          try {
            const name = identifierInput.trim();
            await onSubmit({
              name,
              identifier: name,
              password,
            });
          } catch (err) {
            setSubmitError(err?.message || (isEn ? 'Sign in failed' : '登录失败'));
          }
        }}
      >
        <Stack gap={3}>
          <Field.Root required>
            <Input
              value={identifierInput}
              onChange={(e) => {
                setIdentifierInput(e.target.value);
                if (submitError) setSubmitError('');
              }}
              placeholder={isEn ? 'Username or email' : '用户名或邮箱'}
              borderRadius="lg"
              bg={{ base: 'white', _dark: 'gray.900' }}
            />
          </Field.Root>
          <Field.Root required>
            <Input
              type="password"
              value={password}
              onChange={(e) => {
                setPassword(e.target.value);
                if (submitError) setSubmitError('');
              }}
              placeholder={isEn ? 'Password' : '密码'}
              minLength={8}
              borderRadius="lg"
              bg={{ base: 'white', _dark: 'gray.900' }}
            />
          </Field.Root>
        </Stack>
        <LinkButton
          mt={2}
          onClick={() => {
            if (typeof onForgotPassword === 'function') onForgotPassword();
          }}
        >
          {isEn ? 'Forgot password?' : '忘记密码？'}
        </LinkButton>
        <FormActions>
          <PrimaryButton>{isEn ? 'Log in' : '登录'}</PrimaryButton>
          <SecondaryButton onClick={onSwitch}>{isEn ? 'Go to sign up' : '去注册'}</SecondaryButton>
          <SecondaryButton onClick={onClose}>{isEn ? 'Close' : '关闭'}</SecondaryButton>
        </FormActions>
      </form>
    </AuthDialog>
  );
}

export default LoginModal;
